import { handleActions, combineActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [rawActions.getIterationDeploymentStatus.request](state, { payload }) {
      return true
    },
    [combineActions(rawActions.getIterationDeploymentStatus.success, rawActions.getIterationDeploymentStatus.failed)](
      state,
      { payload }
    ) {
      return false
    },
  },
  defaultState
)
